import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { reprocess_inputs_and_create_new_run_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { AUTOMATION_RUNS_KEY, PROJECT_RUNS_KEY } from '@/utils/queryKeys.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { Run } from '@/types/runs.ts';
import { watchRun } from '@/features/runBrowserNotifications/watchedRuns.ts';

type props = {
  runId: string;
};

const useReprocessInputsAndCreateNewRun = (): UseMutationResult<Run, AxiosError, props> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ runId }: props) => {
      const response = await apiClient.put(reprocess_inputs_and_create_new_run_url(runId));

      await queryClient.invalidateQueries({ queryKey: AUTOMATION_RUNS_KEY(automationId) });
      await queryClient.invalidateQueries({ queryKey: PROJECT_RUNS_KEY });

      watchRun({
        automationId,
        run: response.data,
      });

      return response.data;
    },
  });
};

export default useReprocessInputsAndCreateNewRun;
